export const alertOutlinedWarningStylesAlt = theme => ({
  color: theme.palette.warning.dark,
  marginTop: theme.spacing(1.5),
  textAlign: 'center',
});

export const alertOutlinedWarningStyles = theme => ({
  '& .MuiAlert-icon': {
    color: theme.palette._next.info.main,
    left: 16,
    marginRight: 0,
    marginTop: 0,
    padding: 0,
    position: 'absolute',
    top: 12,
  },
  '& .MuiAlert-message': {
    letterSpacing: '0.5px',
    padding: 0,
    paddingLeft: theme.spacing(4),
    textAlign: 'left',
  },
  '&.MuiAlert-root': {
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
    position: 'relative',
  },
  borderColor: theme.palette._next.info.main,
  color: theme.palette._next._components.alert.info.color,
  marginTop: theme.spacing(1.5),
  padding: '14px 16px',
  textAlign: 'center',
});
export const alertRootStylesAlt = theme => ({
  fontSize: 12,
  padding: `0 ${theme.spacing(0.5)}`,
});

export const alertRootStyles = () => ({
  fontFamily: 'Overpass',
  fontSize: 14,
  fontWeight: 400,
});

export const calendarContentStyles = theme => ({
  display: 'grid',
  gridAutoFlow: 'row',
  gridRowGap: theme.spacing(1),
});

export const contentStyles = theme => ({
  display: 'grid',
  gridAutoFlow: 'row',
  gridRowGap: theme.spacing(2),
});

export const withBottomMarginStyles = theme => ({
  marginBottom: theme.spacing(3),
});

export const withVerticalMarginStyles = theme => ({
  margin: theme.spacing(2, 0),
});
